import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=89b489ce&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=89b489ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b489ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89b489ce')) {
      api.createRecord('89b489ce', component.options)
    } else {
      api.reload('89b489ce', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=89b489ce&scoped=true&", function () {
      api.rerender('89b489ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/comp/DocBox.vue"
export default component.exports